@if (open) {
  <div
    class="tfr-modal-overlay"
    role="presentation"
    (click)="onBackdropClick()">
    <div
      class="tfr-modal-panel max-w-md"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="crm-delete-lead-title"
      aria-describedby="crm-delete-lead-desc"
      (click)="$event.stopPropagation()">

      <div class="flex items-start gap-3 mb-4">
        <span class="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-red-50 text-red-600">
          <lucide-icon name="trash-2" class="h-5 w-5" />
        </span>
        <div class="min-w-0">
          <h2 id="crm-delete-lead-title" class="text-[15px] font-bold text-midnight-indigo">
            &iquest;Eliminar este lead?
          </h2>
          <p id="crm-delete-lead-desc" class="mt-2 text-[12px] leading-relaxed text-steel-gray">
            Se borrar&aacute; <strong class="text-midnight-indigo">{{ leadLabel }}</strong>
            con todos sus locales y actividades. Esta acci&oacute;n no se puede deshacer.
          </p>
        </div>
      </div>

      <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          (click)="cancelled.emit()"
          [disabled]="deleting"
          class="rounded-xl border border-pale-gray px-4 py-2.5 text-[13px] font-semibold text-steel-gray hover:bg-cloud-mist disabled:opacity-50">
          Cancelar
        </button>
        <button
          type="button"
          (click)="confirmed.emit()"
          [disabled]="deleting"
          class="rounded-xl bg-red-600 px-4 py-2.5 text-[13px] font-semibold text-white hover:bg-red-700 disabled:opacity-50">
          @if (deleting) {
            Eliminando&hellip;
          } @else {
            S&iacute;, eliminar
          }
        </button>
      </div>
    </div>
  </div>
}
